/**
 *
 * Question
 *
 */

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Feedback',

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isShowObjQaFeedbackContent() {
      return (
        //(this.ms_qaQuestion.isMyQuestion || this.mg_userInfo.studentId === this.p_objQa.userId) &&
        this.p_objQa.feedbackContent
      );
    },
  },
};
